import { render, staticRenderFns } from "./ModalPreparadas.vue?vue&type=template&id=2b6b66a2"
import script from "./ModalPreparadas.vue?vue&type=script&lang=js"
export * from "./ModalPreparadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports